import { TFunction } from 'i18next';

import type { ComplianceProfile } from '~/services/compliance';

export const getSubscriptionTitle = (
  t: TFunction,
  complianceProfile: Pick<ComplianceProfile, 'directCancellationFromSettings'>,
): string =>
  complianceProfile.directCancellationFromSettings
    ? t('general:manage_subscription', 'Manage Subscription')
    : t('general:subscription', 'Subscription');
